import { Badge, createStyles, makeStyles } from "@material-ui/core";
import qs from "qs";
import * as React from "react";

import { MessageIcon, MessageSearchCriteria } from "../..";
import {
    AppMenuItem,
    baseColors,
    mergeClasses,
    RelodeTheme,
} from "../../components";
import {
    useMessageCheckerContext,
} from "./messageChecker/messageCheckerProvider";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            badge: {
                backgroundColor: baseColors.magenta,
            },
        }),
    { name: "MessageMenuItem" }
);

export interface MessageMenuItemProps {
    appContext: string;
    classes?: Partial<ReturnType<typeof useStyles>>;
    type: "system"; // prop is required for util that iterates menu items
    route?: string;
    className?: string;
}

const initialMessageSearchCriteria: MessageSearchCriteria = {
    box: "inbox",
    pageIndex: 1,
    pageSize: 25,
    sortDir: "desc",
    sortField: "createTimestamp",
    searchText: "",
};

const initialMessageSearchQueryParams = qs.stringify(
    initialMessageSearchCriteria,
    {
        skipNulls: true,
        addQueryPrefix: true,
        sort: (a, b) => a.localeCompare(b),
    }
);

export const MessageMenuItem = (props: MessageMenuItemProps) => {
    const {
        classes: classesProp,
        appContext,
        type = "system",
        route = `/messages${initialMessageSearchQueryParams}`,
        ...rest
    } = props;
    const classes = mergeClasses(useStyles({}), classesProp);

    const {
        state: { unreadCount },
    } = useMessageCheckerContext();

    return (
        <AppMenuItem
            {...rest}
            id="messages"
            label="messages"
            tooltip="view and send messages"
            icon={
                <Badge
                    badgeContent={unreadCount}
                    color="primary"
                    variant="standard"
                    classes={{ badge: classes.badge }}
                    max={99}
                >
                    <MessageIcon />
                </Badge>
            }
            type="system"
            route={route}
        />
    );
};
